import IAppConfig from "./IAppConfig";

declare const appConfig: IAppConfig;

const conf = {
  ...appConfig,
};

export default conf;
